module.exports = __webpack_public_path__ + "img/KC_BG1.d83d26f7.png";